import type { IOnboardingStep } from "@/types/Onboarding.types"

const introduction: IOnboardingStep = {
  stepNumber: 1,
  actionTitle: "Allons y !",
  i18ncode: "onboarding/introduction.introduction_presentation.action_button",
  slug: "presentation",
}

const etab: IOnboardingStep = {
  stepNumber: 1,
  actionTitle: "Voir les résultats",
  i18ncode: "onboarding/establishment.establishment_list_choice.action_button",
  slug: "establishment",
}

const result: IOnboardingStep = {
  stepNumber: 2,
  actionTitle: "Passer à l'action",
  i18ncode: "onboarding/analyse.results.action_button",
  slug: "analyse",
}

const account: IOnboardingStep = {
  stepNumber: 3,
  actionTitle: null,
  i18ncode: "action_button",
  slug: "howtocreatemyaccount",
}

// Séquence du onboarding pour les utilisateurs venant de l'espace pro
export const onboardingStepsPro: { [name: string]: IOnboardingStep } = {
  "1": introduction,
  "2": etab,
  "3": result,
  "4": account,
}

const informations: IOnboardingStep = {
  stepNumber: 1,
  actionTitle: null,
  i18ncode: null,
  slug: "begin",
}

// Séquence du onboarding pour les utilisateurs venant d'autres sources'
export const onboardingSteps: { [name: string]: IOnboardingStep } = {
  "1": introduction,
  "2": informations,
  "3": result,
  "4": account,
}
